module.exports = __webpack_public_path__ + "../fonts/slick.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.woff
// module id = 279
// module chunks = 0 1